import { render, staticRenderFns } from "./ItemTopActions.vue?vue&type=template&id=84ad4228&scoped=true"
import script from "./ItemTopActions.vue?vue&type=script&lang=js"
export * from "./ItemTopActions.vue?vue&type=script&lang=js"
import style0 from "./ItemTopActions.vue?vue&type=style&index=0&id=84ad4228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ad4228",
  null
  
)

export default component.exports